/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';
// import ClassAveragesChart from 'edrolo/components/exams/charts/ClassAveragesChart';
import TeacherMarkingSummary from './TeacherMarkingSummary';
import ExamTable from './ExamTable';
import urlResolver from 'edrolo/utils/URLResolver';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

class ExamGrid extends Component {
  render() {
    const {
      deleteExamSitting,
      examData,
      sittingData,
      solutionData,
      markedQuestionsBySection,
      markedQuestionsForExam,
      classAveragesBySection,
      totalMarksAttemptedPerSitting,
      totalMarksObtainedPerSitting,
      sortedStudents,
      isAnonymized,
      handleChangedResponse,
      onChangedResponse,
      classData,
      highlightProfileId,
    } = this.props;

    const renderTeacherMarkingSummary = () => {
      const submissions = _.filter(sittingData, 'submitted_ts');
      const submissionCount = submissions.length;
      const commentCount = _(submissions)
        .map('responses')
        .flatten()
        .filter('comment_from_teacher')
        .size();

      const isMarkableQuestion = (question) =>
        ![
          EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE,
          EXAM_QUESTION_TYPES.PARENT,
        ].includes(question.question_type);

      const hasMarkableQuestions =
        _(examData.sections)
          .map('flatQuestions')
          .flatten()
          .filter(isMarkableQuestion)
          .value().length > 0;

      const markExamUrl = urlResolver.reverse('class-exam-marking', {
        classId: classData.id,
        examId: examData.id,
      });

      const solutionsLink = classData.show_exam_solutions_links
        ? `${examData.solution_print_url}`
        : '';

      return (
        <TeacherMarkingSummary
          studentCount={classData.students.length}
          submissionCount={submissionCount}
          commentCount={commentCount}
          hasMarkableQuestions={hasMarkableQuestions}
          markExamUrl={markExamUrl}
          examSolutionsUrl={solutionsLink}
        />
      );
    };

    const analyticsPayload = {
      class_id: classData.id,
      school_id: classData.school,
      course_id: classData.course_id,
      branch_id: examData.branch_id,
      exam_id: examData.id,
    };

    return (
      <>
        {examData.is_submittable ? renderTeacherMarkingSummary() : null}
        <div
          className="exam-grid"
          id="exam-grid"
          data-test="exam-grid"
          data-appcues="exam-grid"
        >
          <ExamTable
            deleteExamSitting={deleteExamSitting}
            examData={examData}
            sittingData={sittingData}
            solutionData={solutionData}
            markedQuestionsBySection={markedQuestionsBySection}
            markedQuestionsForExam={markedQuestionsForExam}
            classAveragesBySection={classAveragesBySection}
            totalMarksAttemptedPerSitting={totalMarksAttemptedPerSitting}
            totalMarksObtainedPerSitting={totalMarksObtainedPerSitting}
            sortedStudents={sortedStudents}
            isAnonymized={isAnonymized}
            handleChangedResponse={handleChangedResponse}
            onChangedResponse={onChangedResponse}
            analyticsPayload={analyticsPayload}
            highlightProfileId={highlightProfileId}
          />
        </div>
      </>
    );
  }
}

export default ExamGrid;
